import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipedWarningIcon } from '../../../../ui-kit';

interface IncompleteDataDisclaimerProps {
    productWithNoRecipeCount?: number | null;
}

const IncompleteDataDisclaimer = ({ productWithNoRecipeCount }: IncompleteDataDisclaimerProps) => {
    const { t } = useTranslation();

    if (!productWithNoRecipeCount) {
        return null;
    }

    const tooltipText = t(
        '{{count}} product doesn\'t have a recipe. These product\'s margin will not be calculated, therefore data might be not accurate. ',
        { count: productWithNoRecipeCount }
    ) as string;

    return (
        <TooltipedWarningIcon
            tooltipFontSize='0.75rem'
            tooltip={tooltipText}
        />
    );
};

export default IncompleteDataDisclaimer;